export const VENUE_TABS = {
  SERVICES: "services",
  ASK_QUESTION: "ask-question",
  CREW: "crew",
  COMMENTS: "comments",
  DISCOUNTS: "discounts",
  CAMPAIGNS: "campaigns",
  EVENTS: "events",
  PHOTOS: "photos",
  VIDEOS: "videos",
  ABOUT: "about",
  CONTACT: "contact",
  WORKING_HOURS: "working-hours",
  COMPANIES: "company-discounts",
};
